<template>
  <div class="about" v-on:click="show_node_popin = false">
    <h1>About us</h1>

    <p>Founded in 2014, ACINQ is a startup building products and services for the Bitcoin ecosystem.</p>
    <p>We have been contributing to and building upon the Lightning protocol since 2015. Our core technological foundation is <a href="https://github.com/ACINQ/eclair" target="_blank">eclair</a>, a full implementation of Lightning with a focus on performance and reliability.</p>
    <p>ACINQ is a major operator and liquidity provider on the Lightning Network. We run a <router-link to="/node">high capacity node on the network</router-link> where we leverage our expertise of Lightning.</p>
    <p>We also are the developers of <a href="https://phoenix.acinq.co" target="_blank">Phoenix</a>, a cutting-edge self-custodial Bitcoin Lightning wallet.</p>

    <h5 class="text-title limiter">Our <svg-zap />Lightning node</h5>
    <div class="connect">
      <input ref="nodeInput" type="text" :value="node_address" v-on:click="selectInputContent" readonly />
      <!-- qrcode -->
      <div class="qrcode-wrapper" @click.stop>
        <div class="qrcode-popin" v-show="show_node_popin" v-on:close="show_node_popin = false" title="ACINQ Node">
          <img src="/images/node-qrcode.png" width="200" />
          <button class="button transparent text-sm" v-on:click="show_node_popin = false"><svg-close />Close</button>
        </div>
        <button class="button transparent" v-on:click="show_node_popin = !show_node_popin"><svg-qrcode /></button>
      </div>
      <!-- copy -->
      <button class="button transparent" v-clipboard:copy="node_address" v-clipboard:success="onCopy" v-clipboard:error="onError">
        <svg-copy /><span v-if="copy_success" class="text-sm">&nbsp;Copied!</span>
      </button>
    </div>

    <h5 class="text-title limiter">They talk about us...</h5>
    <ul class="media">
      <li><a href="https://www.bloomberg.com/news/articles/2017-12-04/battle-for-true-bitcoin-is-just-getting-started-quicktake-q-a" target="_blank"><img src="images/media/bloomberg.svg" /></a></li>
      <li><a href="https://www.wired.com/story/the-lightning-network-could-make-bitcoin-faster-and-cheaper/" target="_blank"><img src="images/media/wired.svg" /></a></li>
      <li><a href="https://arstechnica.com/tech-policy/2018/02/bitcoins-lightning-network-a-deep-dive/" target="_blank"><img src="images/media/arstechnica.svg" /></a></li>
      <li><a href="https://www.forbes.com/sites/jonathanchester/2018/06/18/your-guide-on-the-lightning-network-the-opportunities-and-the-issues/#350215ba3677" target="_blank"><img src="images/media/forbes.png" /></a></li>
      <li><a href="https://finance.yahoo.com/news/first-lightning-network-wallet-app-203119473.html" target="_blank"><img src="images/media/yahoo-finance.png" /></a></li>
      <li><a href="https://www.coindesk.com/lightning-last-test-shows-bitcoin-scaling-solution-almost-ready" target="_blank"><img src="images/media/coindesk.png" /></a></li>
      <li><a href="https://bitcoinmagazine.com/articles/future-bitcoin-what-lightning-could-look/" target="_blank"><img src="images/media/btc-magazine.png" /></a></li>
    </ul>



  </div>
</template>

<script>
import SvgDownload from '@/assets/icons/download.svg'
import SvgMail from '@/assets/icons/mail.svg'
import SvgQrcode from '@/assets/icons/qrcode.svg'
import SvgCopy from '@/assets/icons/copy.svg'
import SvgClose from '@/assets/icons/x.svg'
import SvgZap from '@/assets/icons/zap.svg'

export default {
  name: "about",
  metaInfo: {
    title: "About us"
  },
  components: {
    SvgDownload,
    SvgMail,
    SvgQrcode,
    SvgCopy,
    SvgClose,
    SvgZap
  },
  data () {
    return {
      show_node_popin: false,
      copy_success: false,
      node_address: '03864ef025fde8fb587d989186ce6a4a186895ee44a926bfc370e2c366597a3f8f@34.239.230.56:9735'
    }
  },
  methods: {
    onCopy () {
      this.copy_success = true
      setTimeout(() => {
        this.copy_success = false
      }, 2000)
    },
    onError () {
      console.log('copy failed')
    },
    selectInputContent () {
      this.$refs.nodeInput.select()
    },
  }
}
</script>

<style lang="sass">
@import "@/styles/_settings.scss"

.about
  .contact
    margin: $space_md 0
    font-weight: normal

  .details
    @include mq($from: medium)
      display: flex
      flex-direction: row
      align-items: start
      .address
        flex: 0 0 40%
      .stamps
        margin-left: $space_xl
    .address
      p
        margin: 0 0 $space_md
        line-height: 1.46em
    .stamps
      display: flex
      flex-direction: row
      flex-wrap: wrap
      align-items: center
      @include mq($until: medium)
        margin: 0 0 $space_xl
      img
        display: block
        margin: $space_lg $space_xl 0 0
        @include mq($from: medium)
          margin: 0 $space_md $space_lg

  .connect
    display: flex
    align-items: stretch
    font-weight: 700
    input
      flex: 1 1 auto
      min-width: 50px
      max-width: 300px
      border: none
      padding: $space_sm
      background-color: $athens
      margin-right: $space_xs
    button.button
      margin-right: $space_xs
      display: block
      height: 100%
      flex: 0 0 auto
      max-width: 50px
      svg
        display: inline-block
        vertical-align: middle
        width: auto
        height: 24px
        color: $fiord
    .qrcode-wrapper
      position: relative
    .qrcode-popin
      position: absolute
      z-index: 6
      left: -70px
      bottom: 110%
      border-radius: 4px
      box-shadow: 0 10px 35px -5px $geyser
      background-color: white
      text-align: center
      padding: $space_sm
      button.button
        display: inline-flex
        align-items: center
        svg
          vertical-align: middle
          width: 1em
          margin-right: .5em
      img
        display: block
        width: 160px

  ul.media
    padding: $space_md 0 0
    margin: 0
    list-style-type: none
    display: flex
    flex-direction: row
    align-items: center
    flex-wrap: wrap
    justify-content: space-between
    li
      margin: 0 0 $space_md 0
      width: 40%
      img
        max-width: 110px
      @include mq($from: medium)
        margin: 0 0 $space_lg 0
        width: 30%

</style>
